import React, { useState } from "react";
import { getDynamicIconSize } from "../../liveBusLocations/tools";
import MapLocationDotIcon from "../../../components/icons/MapLocationDotIcon";
import {
  Divider,
  IconButton,
  ListItem,
  ListItemText,
  Typography,
} from "@material-ui/core";
import List from "@material-ui/core/List";
import PeopleIcon from "@material-ui/icons/People";
import MoveRouteLocationFromMarkerButton from "../../enhancedRoutePlans/components/MoveRouteLocationFromMarkerButton";
import CloseIcon from "@material-ui/icons/Close";

interface IMarker {
  lat: number;
  lng: number;
  key: string;
  zoom: number;
  order: number;
  data: any;
  colorOne?: string;
  colorTwo?: string;
  isDetailRoute?: boolean;
}

const LocationMarker = ({
  zoom,
  order,
  colorOne,
  colorTwo,
  data,
  isDetailRoute,
}: IMarker) => {
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const iconSize = getDynamicIconSize(zoom);

  return (
    <>
      <div
        style={{
          width: `${iconSize}px`, // Dynamic size based on zoom level
          height: `${iconSize}px`, // Dynamic size based on zoom level
          position: "absolute",
          transform: "translate(-50%, -100%)",
          cursor: "pointer",
          zIndex: isPopupVisible ? 11 : 10,
        }}
        onClick={() => {
          setIsPopupVisible(!isPopupVisible); // Toggle popup locally
        }}
      >
        <MapLocationDotIcon
          width={iconSize}
          height={iconSize}
          colorOne={colorOne}
          colorTwo={colorTwo}
        />

        {/* Number overlay */}
        <span
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            color: "white", // Contrast with the marker image
            fontWeight: "bold",
            fontSize: `${Math.max(10, iconSize * 0.5)}px`, // Scale with iconSize, with a minimum size
            pointerEvents: "none", // Ensures the number doesn't block clicks
          }}
        >
          {order}
        </span>

        {/* Total students overlay */}
        {zoom >= 16 && data.students.length > 0 && (
          <div
            style={{
              position: "absolute",
              left: "50%",
              transform: "translateX(-50%)",
              backgroundColor: "white",
              color: "black",
              padding: "4px",
              borderRadius: "4px",
              boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
              whiteSpace: "nowrap",
              zIndex: 100,
            }}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <PeopleIcon fontSize="small" style={{ marginRight: "4px" }} />
              <span
                style={{
                  fontSize: `${Math.max(10, iconSize * 0.5)}px`,
                  fontWeight: "bold",
                }}
              >
                {data.students.length}
              </span>
            </div>
          </div>
        )}
      </div>

      {/* Conditional Popup */}
      {isPopupVisible && (
        <div
          style={{
            position: "absolute",
            bottom: iconSize + 10, // Show above the marker
            left: "50%",
            transform: "translateX(-50%)",
            backgroundColor: "white",
            color: "black",
            padding: "6px 12px",
            paddingTop: 24,
            borderRadius: "4px",
            boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
            whiteSpace: "nowrap",
            zIndex: 100,
            fontSize: "12px",
            fontWeight: "normal",
          }}
        >
          <IconButton
            size="small"
            onClick={() => setIsPopupVisible(false)}
            style={{
              position: "absolute",
              top: 4,
              right: 4,
              padding: 2,
            }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>

          <Typography variant="body2" gutterBottom>
            <strong>{data.routeName}</strong> - {data.address}
          </Typography>

          {/* only show move button if not detail route */}
          {!isDetailRoute ? (
            <MoveRouteLocationFromMarkerButton
              routeName={data.routeName}
              order={order}
              setIsPopupVisible={setIsPopupVisible}
            />
          ) : (
            <></>
          )}
          {data.students && data.students.length > 0 && (
            <>
              <Divider style={{ margin: "10px 0px" }} />
              <Typography variant="body2" style={{ fontWeight: "bold" }}>
                Students:
              </Typography>
              <List dense style={{ padding: 0 }}>
                {data.students.map((student: any, index: number) => (
                  <ListItem key={index} dense disableGutters>
                    <ListItemText
                      primary={`${student.firstName} ${student.lastName}`}
                    />
                  </ListItem>
                ))}
              </List>
            </>
          )}
        </div>
      )}
    </>
  );
};

export default LocationMarker;
